<!-- <section
  class="bg-white mt-6 rounded-3xl w-full relative flex justify-center transition-all duration-300"
  [ngClass]="{
    'px-3 pb-2 pt-3': selectedTab === 0,
    'px-8 pb-4 pt-8': selectedTab !== 0
  }"
> -->
  <!-- <div class="absolute -top-6 z-10">
    <div
      class="bg-white shadow w-fit flex justify-center gap-3 p-1.5 lg:p-2 rounded-full"
    >
      <button
        *ngFor="let tab of tabs; let i = index"
        (click)="selectTab(i)"
        [ngClass]="selectedTab === i ? 'bg-black text-white' : 'text-gray-600'"
        class="py-1 px-4 cursor-pointer rounded-full text-sm lg:text-base"
      >
        {{ tab.label }}
      </button>
    </div>
  </div> -->
  <!-- <form
    *ngIf="selectedTab === 0"
    class="w-full grid md:grid-cols-2 2xl:grid-cols-4 items-center md:gap-5 lg:gap-5"
  >
    <out-select
      [id]="'model'"
      [name]="'model'"
      [items]="options.model"
      selectClass="!border-b !border-x-0 !border-t-0 !rounded-none !py-3"
      [control]="getControl('model')"
    >
    </out-select>

    <out-select
      [id]="'year'"
      [name]="'year'"
      [items]="options.year"
      selectClass="!border-b !border-x-0 !border-t-0 !rounded-none !py-3"
      [control]="getControl('year')"
    >
    </out-select>
    <out-select
      [id]="'location'"
      [name]="'location'"
      [items]="options.location"
      [control]="getControl('location')"
      selectClass="!border-b !border-x-0 !border-t-0 !rounded-none !py-3"
    >
    </out-select>
    <button
      tabindex="0"
      type="button"
      (click)="goToSearchUrl()"
      class="bg-OUT-Blue cursor-pointer hover:bg-OUT-Blue/90 transition-colors duration-400 w-full rounded-full px-5 py-2 text-white md:mb-7 lg:mb-3.5 lg:-mt-4 font-semibold ring-2 ring-OUT-Blue ring-offset-2 ring-offset-white"
    >
      Search
    </button>
  </form> -->

  <!-- <div *ngIf="selectedTab === 0" class="rounded-3xl h-fit w-full mx-auto">
    <form
      (ngSubmit)="goToChat(input)"
      (keydown.enter)="goToChat(input)"
      class="w-full h-fit rounded-3xl mx-auto space-y- bg-gradient-to-r from-blue-500 p-0.5 to-pink-600 border-2"
    >
      <div
        class="relative w-full h-fit bg-white focus:bg-black/10 rounded-[20.5px]"
      >
        <textarea
          name="input"
          [(ngModel)]="input"
          placeholder="Start chat..."
          class="h-10 overflow-hidden resize-none rounded-3xl text-base bg-muted border-0 focus:border-0 focus:ring-0 flex-1 w-full p-3 focus:outline-none transition-all duration-100 ease-in-out"
        ></textarea>
        <button
          type="submit"
          class="rounded-full p-2 h-fit bg-blue-500 text-white disabled:bg-gray-400 transition-all absolute right-2 top-[3.5px] cursor-pointer"
          [disabled]="input.length === 0"
          aria-label="Send"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            class="rotate-90"
          >
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M11.47 2.47a.75.75 0 0 1 1.06 0l7 6.987a.75.75 0 1 1-1.06 1.061L12.751 4.81L12.762 21a.75.75 0 0 1-1.5.002l-.01-16.194l-5.722 5.711a.75.75 0 1 1-1.06-1.061z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>
      
    </form>
    
      <div class="grid md:grid-cols-2 flex-wrap gap-2 mt-3">
        <button
          *ngFor="let suggestion of suggestions"
          type="button"
          class="hover:underline text-center text-OUT-Blue duration-300 px-3 py-1.5 rounded-full cursor-pointer text-sm transition-colors odd:justify-self-end even:justify-self-start"
          (click)="input = suggestion"
        >
          {{ suggestion }}
        </button>
      </div>
  </div> -->

  <!-- <div
    *ngIf="selectedTab === 1"
    class="flex flex-col lg:flex-row items-center gap-4 lg:gap-2.5 pt-6 pb-4"
  >
    <p
      *ngIf="(auth.isAuthenticated$ | async) === false"
      class="xl:w-[80%] w-full"
    >
      <strong>Thinking of selling your Tesla?</strong> Register for free at Only
      Used Tesla to connect with passionate buyers and access exclusive features
      for the best deal.
    </p>
    <p *ngIf="auth.isAuthenticated$ | async">
      <strong>Thinking of selling your Tesla?</strong> Click on 'Sell My Tesla'
      to start listing your Tesla now
    </p>
    <button
      [routerLink]="
        (auth.isAuthenticated$ | async) ? '/your-tesla' : '/sell-my-tesla'
      "
      class="bg-OUT-Blue cursor-pointer hover:bg-OUT-Blue/90 w-full lg:w-[20%] px-5 py-2 text-white font-semibold hover:bg-OUT-Blue/90 transition-colors duration-400 rounded-full px-5 py-2 lg:-mt-4 ring-2 ring-OUT-Blue ring-offset-2 ring-offset-white"
    >
      Sell My Tesla
    </button>
  </div> -->
<!-- </section> -->


<!-- Filter Form -->
 <section
  class="bg-white mt-6 px-8 pb-4 pt-8 rounded-3xl w-full relative flex justify-center transition-all duration-300"
>
  <!-- Tabs -->
  <div class="absolute -top-6">
    <div
      class="bg-white shadow w-fit flex justify-center gap-3 p-1.5 lg:p-2 rounded-full"
    >
      <button
        *ngFor="let tab of tabs; let i = index"
        (click)="selectTab(i)"
        [ngClass]="selectedTab === i ? 'bg-black text-white' : 'text-gray-600'"
        class="py-1 px-4 cursor-pointer rounded-full text-sm lg:text-base"
      >
        {{ tab.label }}
      </button>
    </div>
  </div>
  <form
    *ngIf="selectedTab === 0"
    class="w-full grid md:grid-cols-2 2xl:grid-cols-4 items-center md:gap-5 lg:gap-5"
  >
    <out-select
      [id]="'model'"
      [name]="'model'"
      [items]="options.model"
      selectClass="!border-b !border-x-0 !border-t-0 !rounded-none !py-3"
      [control]="getControl('model')"
    >
    </out-select>

    <out-select
      [id]="'year'"
      [name]="'year'"
      [items]="options.year"
      selectClass="!border-b !border-x-0 !border-t-0 !rounded-none !py-3"
      [control]="getControl('year')"
    >
    </out-select>
    <out-select
      [id]="'location'"
      [name]="'location'"
      [items]="options.location"
      [control]="getControl('location')"
      selectClass="!border-b !border-x-0 !border-t-0 !rounded-none !py-3"
    >
    </out-select>
    <button
      tabindex="0"
      type="button"
      (click)="goToSearchUrl()"
      class="bg-OUT-Blue cursor-pointer hover:bg-OUT-Blue/90 transition-colors duration-400 w-full rounded-full px-5 py-2 text-white md:mb-7 lg:mb-3.5 lg:-mt-4 font-semibold ring-2 ring-OUT-Blue ring-offset-2 ring-offset-white"
    >
      Search
    </button>
  </form>

  <div
    *ngIf="selectedTab === 1"
    class="flex flex-col lg:flex-row items-center gap-4 lg:gap-2.5 pt-6 pb-4"
  >
    <p
      *ngIf="(auth.isAuthenticated$ | async) === false"
      class="xl:w-[80%] w-full"
    >
      <strong>Thinking of selling your Tesla?</strong> Register for free at Only
      Used Tesla to connect with passionate buyers and access exclusive features
      for the best deal.
    </p>
    <p *ngIf="auth.isAuthenticated$ | async">
      <strong>Thinking of selling your Tesla?</strong> Click on 'Sell My Tesla'
      to start listing your Tesla now
    </p>
    <button
      [routerLink]="
        (auth.isAuthenticated$ | async) ? '/your-tesla' : '/sell-my-tesla'
      "
      class="bg-OUT-Blue cursor-pointer hover:bg-OUT-Blue/90 w-full lg:w-[20%] px-5 py-2 text-white font-semibold hover:bg-OUT-Blue/90 transition-colors duration-400  rounded-full px-5 py-2 lg:-mt-4  ring-2 ring-OUT-Blue ring-offset-2 ring-offset-white"
    >
      Sell My Tesla
    </button>
  </div>
</section>